<template>
	<AppDetailCard
		:title-item-list="titleItemList"
		:body-content-list="bodyContentList"
		:body-content-styles="bodyContentStyles"
	/>
</template>

<script>
import AppDetailCard from '@/components/UI/AppDetailCard';

import { formatDateString } from '@/utils/util';

import asStamp from '@/assets/images/asStamp/stamp.png';

export default {
	components: {
		AppDetailCard,
	},
	props: {
		asDetail: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		titleItemList() {
			return ['텐텐쿠폰 스탬프 적립', '관리 1회'];
		},
		brachName() {
			return this.$store.getters['appStore/branchName'];
		},
		bodyContentList() {
			return [
				{
					label: '구분',
					value: this.getAsDetailStatusName(),
				},
				{
					label: '지점',
					value: this.brachName,
				},
				{
					label: '날짜',
					value: `${formatDateString(this.asDetail.PYMNT_DT)}`,
				},
				{
					label: '상세',
					value: this.asDetail.SV_NAME,
				},
			];
		},
		bodyContentStyles() {
			const availableStatusStyles =
				this.asDetail.GUBUN === 'A'
					? {
							background: `url(${asStamp}) no-repeat right .5rem bottom .5rem / 48px auto`,
					  }
					: {};

			return {
				...availableStatusStyles,
			};
		},
	},
	created() {
		this.fetchBranchNameFromBranchCode();
	},
	methods: {
		async fetchBranchNameFromBranchCode() {
			const payload = {
				branchCode: this.asDetail.SAUPJANG,
			};
			return await this.$store.dispatch(
				'appStore/getbranchNameFromBranchCode',
				payload,
			);
		},
		getAsDetailStatusName() {
			const { GUBUN } = this.asDetail;

			if (GUBUN === 'A') {
				return '쿠폰 전환 전';
			}
			if (GUBUN === 'C') {
				return '쿠폰 발행 완료';
			}
			if (GUBUN === 'M') {
				return '만료';
			}

			return '';
		},
	},
};
</script>
